export enum RoleType {
  Admin = 'Admin',
  Support = 'Support',
  Production = 'Production',
  Technician = 'Technician',
  Sales = 'Sales',
  DataOperator = 'DataOperator',
}

export enum AuthPage {
  Administration = 'administration',
  UserCustomerView = 'users-customers',
  Marketable = 'marketable',
  DataIncoming = 'data-incoming',
  DataPublishing = 'data-publishing',
  Stadium = 'stadium',
  Stadiums = 'stadiums',
  License = 'license',
  MediaReports = 'media-reports',
  PermissionManagement = 'permission-management',
  PlayersManager = 'players-manager',
  NotPermitted = 'not-permitted',
  Playground = 'playground',
}

export enum AuthFeature {
  ReportIssue = 'report-issue',
  SetMatchQualifier = 'set-match-qualifier',
}

export enum OAuthErrorCode {
  AccessDenied = 'access_denied',
}
